import React from "react";
import { ISelectedReportContext } from "./SelectedReportContextTypes";

export const reportContext = React.createContext<ISelectedReportContext>({
  setReport: (value) => {},
  clearReport: () => {},
});

export const useSelectedReportContext = () => React.useContext(reportContext);

export default reportContext;

const Provider = reportContext.Provider;
export const SelectedReportContextProvider = (
  props: React.PropsWithChildren<{}>
) => {
  const [state, setState] = React.useState<ISelectedReportContext>({
    report: (() => {
      try {
        const value = window.localStorage.getItem("SelectedReport");
        if (typeof value === "string" && value) {
          const item = JSON.parse(value);
          return item;
        }
        return undefined;
      } catch (e) {
        return undefined;
      }
    })(),
    setReport: (newReport) => {
      window.localStorage.setItem("SelectedReport", JSON.stringify(newReport));
      setState((value) => {
        return { ...value, report: newReport };
      });
    },
    clearReport: () => {
      window.localStorage.setItem("SelectedReport", "");
      setState((value) => {
        return { ...value, report: null };
      });
    },
  });
  return <Provider value={state}>{props.children}</Provider>;
};
